import { useContext } from 'react'
import { useQuery } from 'react-query'

//contexts
import AuthContext from 'context/AuthContext'
//services
import { getTremendousCampaign } from 'services/giftCardsService'
//utils
import { handleError } from 'utils/utils'

const useQueryTremendousCampaign = (campaignId: string) => {
  const { user } = useContext(AuthContext)

  const { data, isLoading } = useQuery(
    ['TREMENDOUS_CAMPAIGN_ID', campaignId],
    () => getTremendousCampaign(campaignId),
    {
      enabled: user?.country !== 'United States',
      onError: handleError,
    }
  )

  return {
    campaign: data?.data?.campaign,
    timeLimit: data?.data?.timeLimit ?? null,
    isLoadingTremendousCampaign: isLoading,
  }
}

export default useQueryTremendousCampaign
